import { getCaSettingByKey } from "../../../../../builders/settings/CaSetting";
import { FA_REGISTER_PRIOR_YEAR_SOURCE } from "../../../../../utils/static/CASchedule";

export const getPriorYaDisposalKey = (caName, ya, yearsBf) =>
  JSON.stringify([caName, String(ya), String(yearsBf)]);

const isFARegisterRow = (row) =>
  row.faRegisterSource ||
  row.isImportedFromFARegister ||
  row.source?.source === "FA Register" ||
  row.source === "FA Register" ||
  row.source?.type === FA_REGISTER_PRIOR_YEAR_SOURCE;

// Use only the FA Disposal summary passed to populateTwdvToDisposal.
export const getPriorYaDisposalOptions = (
  twdvDetails = [],
  caSettings = [],
  caType,
  priorYaRows = [],
) => {
  const autoPopulatedKeys = new Set(
    priorYaRows
      .filter(isFARegisterRow)
      .map((row) =>
        getPriorYaDisposalKey(
          row.caName === "S16 - (LIA / IBA)" ? row.s16Type : row.caName,
          row.ya,
          row.noOfYearClaimsBf,
        ),
      ),
  );

  return twdvDetails
    .map((summary, index) => {
      const setting = getCaSettingByKey(caSettings, summary.caName);
      const isHirePurchase =
        summary.isHirePurchase === true ||
        ["true", "yes", "1"].includes(
          String(summary.isHirePurchase).trim().toLowerCase(),
        );
      const groupKey = getPriorYaDisposalKey(
        summary.caName,
        summary.yaOfPurchase,
        summary.noOfYearsBf,
      );
      // Keep matching against the complete source used by population's find().
      const firstMatch = twdvDetails.findIndex(
        (entry) =>
          entry.caName === summary.caName &&
          Number(entry.yaOfPurchase) === Number(summary.yaOfPurchase) &&
          entry.noOfYearsBf === summary.noOfYearsBf,
      );
      const disabledReason = !setting
        ? "CA setting unavailable"
        : setting.caType !== caType
          ? `${setting.caType} schedule`
          : isHirePurchase
            ? "Hire Purchase"
            : firstMatch !== index
              ? "Duplicate matching fields"
              : "";

      return {
        ...summary,
        key: `${groupKey}:${index}`,
        groupKey,
        caType: setting?.caType,
        noOfYearClaims: setting?.numberOfYears,
        disabledReason,
      };
    })
    .filter(
      (option) =>
        !isFARegisterRow(option) && !autoPopulatedKeys.has(option.groupKey),
    );
};
